import moment from "moment";
import React, { Component } from "react";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import { yearOptions } from "../../../config";
import {
  generatePayloadPrint,
  tableConfig,
  transformMonthlyData,
} from "./config";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import Api from "../../../../../../Services/Api";
import { HttpStatus } from "../../../../../common/Constants";
import { saveAs } from "file-saver";
export default class LaporanServiceYTD extends Component {
  constructor(props) {
    super(props);
    this.currentYear = Number(moment().format("YYYY"));
    this.state = {
      year: yearOptions.find((item) => item.value === this.currentYear),
      dataTable: [],
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps) {
    const currCabang = this.props?.kodeCabang;
    const prevCabang = prevProps?.kodeCabang;
    const currSearch = this.props?.doSearch;
    const prevSearch = prevProps?.doSearch;

    if (
      JSON.stringify(currCabang) !== JSON.stringify(prevCabang) ||
      (currSearch && currSearch !== prevSearch)
    ) {
      this.fetchData();
    }
  }

  handleChangeValue = (name, value) => {
    this.setState((prevValue) => ({ ...prevValue, [name]: value }));
  };

  handleSearch = () => {
    this.fetchData();
  };

  fetchData = async () => {
    const { setError, onTriggerLoading, kodeCabang, onSuccess } = this.props;
    const { year } = this.state;
    const userId = localStorage.getItem("userId");
    if (!kodeCabang) return;

    onTriggerLoading();

    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanServiceYTDH23,
      setError: setError,
      menuName: "Dashboard Level Kabeng Keatas - Laporan Servis YTD",
      args: {
        year: year?.value,
        listCabang: kodeCabang,
        employeeIdMechanic: userId,
      },
    });

    onTriggerLoading();
    onSuccess();

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState({
        dataTable: transformMonthlyData(res.data.data || []),
      });
    }
  };

  handlePrint = async () => {
    const { onTriggerLoading, setError } = this.props;
    const { dataTable } = this.state;
    onTriggerLoading();
    const title = "Laporan Servis YTD";
    const fileName = title.split(" ").join("_");

    const reqBody = {
      filename: fileName,
      sheets: [
        {
          name: title,
          headers: tableConfig.map((item) => item.label),
          data: dataTable.map((item, index) => generatePayloadPrint(item)),
        },
      ],
    };
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT").generateExcelFromPayload,
      setError: setError,
      menuName: "Dashboard Kabeng Keatas - Laporan Service YTD",
      args: reqBody,
    });
    onTriggerLoading();
    if (res.ok) {
      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, fileName + ".xlsx");
    }
  };

  render() {
    const { year, dataTable } = this.state;
    return (
      <React.Fragment>
        <FlexView className="margin-top-15px" style={{ gap: "20px" }}>
          <SimpleDDL
            id="select_options_tahun"
            box="search"
            name="year"
            containerclassname="width width-150px"
            placeholder="Tahun"
            options={yearOptions}
            value={year}
            onChange={(value, { name }) => this.handleChangeValue(name, value)}
          />
          <SimpleButton
            id="btn_search"
            text="Cari"
            className="margin margin-top-5px"
            onClick={() => this.handleSearch()}
          />
        </FlexView>
        <SimpleDataTable
          data={dataTable}
          columns={tableConfig}
          options={{ pagination: false }}
        />
        <FlexView hAlignContent="right" className="margin-top-20px">
          <SimpleButton
            id="btn_print"
            text="CETAK"
            onClick={() => this.handlePrint()}
          />
        </FlexView>
      </React.Fragment>
    );
  }
}
